import { Search } from "@mui/icons-material";

const ModuleFilters = ({
    onSearchChange,
    statusFilter,
    onStatusFilterChange,
    categoryFilter,
    onCategoryFilterChange,
    typeFilter,
    onTypeFilterChange
}) => {
    return (
        <div className="modules-filters-card">
            <div className="modules-search-container">
                <Search className="modules-search-icon" />
                <input
                    type="text"
                    placeholder="Search modules..."
                    onChange={onSearchChange}
                    className="modules-search-input"
                />
            </div>
            <div className="modules-filters-group">
                <select
                    value={statusFilter}
                    onChange={onStatusFilterChange}
                    className="modules-filter-select"
                >
                    <option value="all">Filter by status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                </select>
                {/* <select
                    value={categoryFilter}
                    onChange={onCategoryFilterChange}
                    className="modules-filter-select"
                >
                    <option value="all">Filter by category</option>
                    <option value="internal">Internal</option>
                    <option value="external">External</option>
                    <option value="partner">Partner</option>
                    <option value="all">All</option>
                </select> */}
                {/* <select
                    value={typeFilter}
                    onChange={onTypeFilterChange}
                    className="modules-filter-select"
                >
                    <option value="all">Filter by type</option>
                    <option value="admin">Admin</option>
                    <option value="User">User</option>
                    <option value="Advisor">Advisor</option>
                    <option value="Member">Member</option>
                </select> */}
            </div>
        </div>
    );
};

export default ModuleFilters;

